define('Components/MediaWidget/js/models/MediaWidgetInstanceModel',['underscore','backbone','WidgetInstanceModel','app'],function(_,Backbone,WidgetInstanceModel,app){

    var MediaModel = Backbone.Model.extend({
        getTitle:function(){
            return this.get('title');
        },
        getCTAUrl:function(){
            return this.get('calltoactiontarget');
        },
        getCTAText:function(){
            return this.get('calltoactiontext');
        },
        getImageId:function(){
            return this.get('image');
        },
        getImage: function(suffix,format){
            suffix = suffix ? suffix : '1080x1080';
            format = format ? format : 'JPG';

            var id_picture = this.get('image'),
                url = app.getPictureUrl(id_picture,'Widget',suffix,format,this.getTitle());
            return url || false;
        },
        getVideo: function(){
            if(this.get('videourl') != ''){
                return app.getThemeUrl()+'medias/videos/strat1.mp4';
            }else{
                return false;
            }
        }
    });

    return WidgetInstanceModel.extend({
        name:'MediaWidgetModel',

        isUnique:function(){
            return this.getMedias().size() == 1;
        },
        getNbItems:function(){
            return Math.min(parseInt(this.p('nbItems')), 4);
        },
        getMediaAsObject:function(n){
            // transforme les params en objets
            var model = this,
                active = model.p('active'+n)=='1',
                title = model.p('title'+n);
            return {
                active:active,
                title:title,
                id:n,
                videourl:model.get('params')['videourl'+n],
                image:model.p('image'+n),
                calltoactiontext:model.p('calltoactiontext'+n),
                calltoactiontarget:model.p('calltoactiontarget'+n)
            }
        },
        getMedias:function(){
            var model = this,
                mediaCollection = model.mediaCollection;
            if(!mediaCollection){
                mediaCollection = model.mediaCollection = new Backbone.Collection();
                mediaCollection.model = MediaModel;
                for(var i=1; i<=4; i++){
                    var attributes = model.getMediaAsObject(i);
                    if(attributes.active){
                        mediaCollection.add(attributes);
                    }
                }
            }
            return mediaCollection;
        },
        isFluid: function(){
            console.log('isFLUID', this.p('fluid'), this.getNbItems() == 1 || (this.p('fluid') == 1 && this.getNbItems() <= 2));
            return this.getNbItems() == 1 || (this.p('fluid') == 1 && this.getNbItems() <= 2);
        }
    })
});
